import axios from "axios";

/**
 * Serviço para obter token de acesso para operações internas da aplicação
 * que exigem autenticação, como registro de usuários.
 */
export class InternalAuthService {
  private baseUrl: string;
  private internalUserEmail: string;
  private internalUserPassword: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_URL || "https://api-qas.talk2buy.com.br";
    this.internalUserEmail = import.meta.env.VITE_INTERNAL_USER_EMAIL || "";
    this.internalUserPassword = import.meta.env.VITE_INTERNAL_USER_PASSWORD || "";
  }

  /**
   * Obtém um token de acesso usando credenciais internas
   * @returns Promise com o token de acesso
   */
  async getAccessToken(): Promise<string> {
    try {
      if (!this.internalUserEmail || !this.internalUserPassword) {
        throw new Error("Credenciais internas não configuradas");
      }

      const response = await axios.post(`${this.baseUrl}/api/v1/login`, {
        login: this.internalUserEmail,
        password: this.internalUserPassword,
      });

      if (response.data && response.data.accessToken) {
        return response.data.accessToken;
      }

      throw new Error("Token de acesso não encontrado na resposta");
    } catch (error) {
      console.error("Erro ao obter token de acesso interno:", error);
      throw new Error("Falha ao obter token de acesso interno");
    }
  }
}

export const internalAuthService = new InternalAuthService();
export default internalAuthService;
